module.exports = __webpack_public_path__ + "img/userPhoto.66607358.png";